require('jquery-toast-plugin/dist/jquery.toast.min.js');
require('style-loader!jquery-toast-plugin/dist/jquery.toast.min.css');


// WEBPACK FOOTER //
// ./src/app/theme/services/baToastNotification/baToastNotification.loader.ts